import React from 'react'

import { ExclamationCircleIcon } from '@heroicons/react/24/outline'

export function NoOfferAlert({ onClose }: { onClose: () => void }) {
  return (
    <div>
      <p className='alert alert-warning bg-warning/75'>
        <ExclamationCircleIcon className='h-6 w-6 text-yellow-900' />
        Unable to generate Application documents because this deal has no offers yet.
      </p>
      <div className='mt-5 flex justify-center'>
        <button
          type='button'
          onClick={onClose}
          className='btn btn-primary'
        >
          Close
        </button>
      </div>
    </div>
  )
}
